<!-- eslint-disable vue/no-v-html -->
<template>
  <el-card style="min-height: 300px;">
    <el-collapse accordion class="notice-collapse" @change="handleChange" v-loading="searching">
      <el-collapse-item v-for="notice in noticeList" :key="notice.id" :name="notice.id">
        <template v-slot:title>
          <span class="title" :class="{'not-read': !notice.isRead}">{{ notice.title }}</span>
          <span class="title time" :class="{'not-read': !notice.isRead}">{{ notice.insertTime }}</span>
        </template>
        <span v-html="notice.content" />
      </el-collapse-item>
    </el-collapse>
    <el-pagination
      v-show="showPage"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page.sync="pagination.current"
      :page-sizes="[10, 50, 100, 1000, 2000]"
      :page-size="pagination.size"
      :total="pagination.total"
      layout="total, sizes, prev, pager, next, jumper"
      class="pagination"
    >
    </el-pagination>
  </el-card>
</template>

<script>
import commonService from '@/api/common'

export default {
  name: 'PersonNotice',
  data() {
    return {
      pagination: {
        current: 1,
        size: 10,
        total: 0
      },
      noticeList: [{
        id: 1,
        title: 'test',
        isRead: 0,
        insertTime: '2010-10-1',
        content: '12312312'
      }],
      searching: false
    }
  },
  computed: {
    showPage() {
      return this.pagination.total > 10
    }
  },
  created() {
    this.handleSearch()
  },
  methods: {
    fetchData() {
      const { pagination } = this
      const postData = {
        page: pagination.current - 1,
        num: pagination.size,
      }

      this.searching = true
      commonService.findNotice(postData).then(resp => {
        this.pagination.total = resp.total
        this.noticeList = resp.list
      }).catch(error => {
        this.$message({
          type: 'error',
          message: `查询消息异常：${error.message}`
        })
      }).finally(_ => {
        this.searching = false
      })
    },
    handleSearch() {
      this.pagination.current = 1

      this.fetchData()
    },
    handleSizeChange(size) {
      this.pagination.size = size
      this.fetchData()
    },

    handleCurrentChange(current) {
      this.fetchData()
    },

    handleChange(noticeId) {
      const notice = this.noticeList.find(n => n.id === noticeId)
      if (noticeId && notice.isRead === 0) {
        const postData = {
          ids: [noticeId],
          isRead: 1
        }
        commonService.readNotice(postData).then(resp => {
          // const notice = this.noticeList.find(notice => notice.id === noticeId)
          notice.isRead = 1

          this.$store.dispatch('GetNotice')
        })
      }
    }
  }
}
</script>

<style lang="scss" socped>
.notice-collapse {
  /deep/ .el-collapse-item__header {
    height: 30px;
    line-height: 30px;
  }

  .title {
    font-weight: 400;
  }
  .not-read {
    font-weight: 700;
  }
  .time {
    position: absolute;
    right: 70px;
  }
}
</style>
